import React, { useEffect } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody
} from 'design-react-kit';
import { showSpinner } from "../utils/elements";

export const SibaExternalLink = ({ targetLink }) => {

  useEffect(() => {
    window.location.replace(targetLink);
    return null;
  }, []);

  // START RENDERING
  return (
    <Modal isOpen={true} popConfirm className="text-center align-middle">
      <ModalHeader className="text-center align-middle" charCode={215} closeAriaLabel="Close" tag="h4" wrapTag="div" >
        ATTENDERE
      </ModalHeader>
      <ModalBody tag="div">
        <p>Redirezione verso pagina desiderata... <br /></p>
        {showSpinner()}
      </ModalBody>
    </Modal>
  )
}

export default SibaExternalLink;